import { render, staticRenderFns } from "./LocationComments.vue?vue&type=template&id=f3f47824&"
import script from "./LocationComments.vue?vue&type=script&lang=js&"
export * from "./LocationComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports